import React from 'react';
import { Col, Form, Row, Typography, Upload } from 'antd';
import { useTranslation } from 'react-i18next';
import { InboxOutlined } from '@ant-design/icons';
import { Descriptions } from 'antd';
import FormHelper from 'helpers/FormHelper';
import { Button } from '../../../../../../../components';

const FileSection = ({ singleItem, isEdit }) => {
  const { t } = useTranslation();
  return (
    <Row gutter={24}>
      <Col span={6}>
        <Typography.Title level={3}>{t('Allegato')}</Typography.Title>
      </Col>
      <Col span={9}>
        <Form.Item label={'Carica Modulo richiesta adesione Originale'}>
          <Form.Item
            name='doc'
            multiple={false}
            valuePropName='fileList'
            getValueFromEvent={FormHelper.normFile}
            noStyle
          >
            <Upload.Dragger
              multiple={false}
              name='doc'
              beforeUpload={FormHelper.beforeUpload}
            >
              <p className='ant-upload-drag-icon'>
                <InboxOutlined />
              </p>
              <p className='ant-upload-text'>
                {t('Click or drag file to this area to upload1')}
                'PDF', 'WORD', 'XLS', 'XLSX', 'PPTX'
                {t('Click or drag file to this area to upload2')}
              </p>
            </Upload.Dragger>
            <Descriptions column={1} bordered>
                  <Descriptions.Item label={`${t('Formati accettati')}:`}>
                  PDF WORD XLS XLSX PPTX
                  </Descriptions.Item>
                  <Descriptions.Item label={`${t('Dimensione massima')}:`}>
                  5MB
                  </Descriptions.Item>
          </Descriptions>
          </Form.Item>
        </Form.Item>
      </Col>
      {isEdit && (
        <Col offset={6} span={9}>
          <Button
            type={'primary-white'}
            onClick={() => window.open(singleItem.file, '_blank')}
          >
            Modulo richiesta adesione originale
          </Button>
        </Col>
      )}
    </Row>
  );
};

export default React.memo(FileSection);
